import { ObservableArray, View } from "binder"
import { ProductBalanceBatchViewModel, item } from "./productBalanceBatch-viewModel"
import { WarehouseMultiSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";

export class ProductBalanceBatchView extends View<ProductBalanceBatchViewModel>{
    GetViewUniqueId(): string {
        return "V-205EF89A-CB23-479C-84AB-4EF034EDE2A2"
    }
    loadHtml(): string {
        let element = require('./productBalanceBatch.html').default;
        let style = require('./productBalanceBatch.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set fromCode(v: string) { this._fromCode = v; } public get fromCode(): string { return this._fromCode;} private _fromCode: string;
    public set toCode(v: string) { this._toCode = v; } public get toCode(): string { return this._toCode;} private _toCode: string;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;
    
    public set warehouseSelector(v: WarehouseMultiSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseMultiSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseMultiSelectorViewModel;
    
    refresh(){
        this.dataContext.refresh();
    }
    exportExcel(){
        this.dataContext.exportExcel();
    }
}
